import { ModuleLoadingService } from './module-loading.service';
import angular = require('angular');
import { ILazyLoadProvider } from 'oclazyload';

export class ModuleLoadingProvider implements angular.IServiceProvider {
  static $inject = ['$ocLazyLoadProvider'];

  service: ModuleLoadingService;

  constructor(private $ocLazyLoadProvider: ILazyLoadProvider) {
    this.$get.$inject = [
      '$ocLazyLoad',
      'ng1NgXUrlHandlingStrategy',
      '$q',
      '$location',
      '$route',
      'cfn-RouteRedirectService',
      'farmnetModuleService'
    ];

    $ocLazyLoadProvider.config({
      debug: false,
      events: true
    });
  }

  $get($ocLazyLoad, ng1NgXUrlHandlingStrategy, $q, $location, $route, cfnRouteRedirectService, farmnetModuleService) {
    this.service = new ModuleLoadingService(
        this,
        farmnetModuleService,
        $ocLazyLoad,
        ng1NgXUrlHandlingStrategy,
        $q,
        $location,
        $route,
        cfnRouteRedirectService
    );

    return this.service;
  }

  /**
   * This method is for use with routeProvider. It's meant to be used on on all routes that are yet unknown
   * but having the same name as a specific route. E.g. on /reporting/ - it tries load a module with that exact name
   * before trying to resolve route again. Since "reporting" module declares that same route on instantiation,
   * a page will be able to load now.
   * returns an object with a promise as resolver.
   */
  resolverLoadLazyByRoute() {
    const previousStagePerRouteslice = {};

    return {
      loadModule: () => {
        return this.service.loadLazyByRoute(previousStagePerRouteslice)
      }
    };
  }

  /**
   * This method is for use with routeProvider. It goes like: Before resolving a specific route,
   * please load these modules ["x","y"] first.
   * returns an object with a promise as resolver.
   */
  resolverLoadLazy(moduleNameList: string | string[]) {

    const modules = typeof moduleNameList === 'string' ?  [moduleNameList] : moduleNameList;

    return [
      () => {
        return this.service.initiateLoading(modules);
      }
    ];
  }

  /**
   * This method is for use with routeProvider. It goes like: Before resolving a specific route,
   * please load all modules first.
   * returns an object with a promise as resolver.
   */
  resolverLoadAll() {
    return [
      () => {
        return this.service.initiateLoadingNotYetLoadedModules();
      }
    ];
  }
}
